import type {
  PosShopFeePaymentType,
  PosShopFeePolicy,
  PosShopFeeQuote,
} from './pos-shop-fees.types'

const IN_STORE_TYPES: PosShopFeePaymentType[] = ['card', 'cash', 'check']

/** The in-store payment types this policy adds a fee to; empty when it doesn't apply in store. */
export function inStoreShopFeeTypes(
  policy: PosShopFeePolicy | null | undefined
): PosShopFeePaymentType[] {
  if (!policy?.enabled || !policy.channels?.includes('pos')) return []

  return IN_STORE_TYPES.filter((type) => policy.payment_types?.includes(type))
}

/** Whether a payment type carries the fee, so the payment screen knows to price it. */
export function shopFeeAppliesTo(
  policy: PosShopFeePolicy | null | undefined,
  paymentType: string | null | undefined
): paymentType is PosShopFeePaymentType {
  return inStoreShopFeeTypes(policy).some((type) => type === paymentType)
}

/** Whether a priced payment adds anything for the customer to pay on top. */
export function quoteAddsToPayment(quote: PosShopFeeQuote): boolean {
  return quote.fee_cents > 0 || quote.tax_cents > 0
}
